import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import type { IpeTileData } from '../../../interfaces/Tile.interface';
import { Page, RoutingService } from '../../../services/routing/routing.service';
import { SpawnableTile } from '../spawnable-tile/spawnable-tile.component';
import { TileIpeGaugeSubComponentComponent } from './tile-ipe-gauge-sub-component/tile-ipe-gauge-sub-component';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./tile-ipe-gauge.scss'],
    selector: 'tile-ipe-gauge',
    templateUrl: 'tile-ipe-gauge.html',
    imports: [TileIpeGaugeSubComponentComponent, AsyncPipe]
})
export class TileIpeGaugeComponent extends SpawnableTile<IpeTileData> {
    private _routingService = inject(RoutingService);

    onEdit(newTileData: IpeTileData) {
        this.edited.next(newTileData);
    }

    onDelete() {
        this.deleted.next();
    }

    navigateToTileHistory() {
        this._routingService.goTo(Page.IPE_HISTORY, {
            buildingId: this.tileData.buildingId,
            tileId: this.tileData.tileId
        });
    }
}
